import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { CosmicLoader } from '@marcianus/design/components';
import { useAccess } from '@/lib/access';
import { ROUTES } from '@/app/routes';

/**
 * Guarda de rota — a permissão é a MESMA string que o backend exige.
 *
 * Isto não é segurança (a segurança está no servidor, e um utilizador curioso
 * pode sempre pedir a rota à API). É correção: um ecrã que carrega e depois
 * enche de 403 é um bug de produto. Aqui, ou tens a capacidade, ou nunca vês o
 * ecrã — e a resposta a "tens?" vem do mesmo sítio que decide no backend.
 *
 * Não confundir com esconder o botão: o botão some porque `can()` diz que não;
 * a rota fecha porque `can()` diz que não. Uma fonte, dois usos.
 */
export function RequirePermission({
  permission,
  children,
  fallback = ROUTES.attendee.explore,
}: {
  permission: string;
  children: ReactNode;
  fallback?: string;
}) {
  const { loading, can } = useAccess();

  // Enquanto não sabemos, não decidimos — mostrar o ecrã e tirá-lo a seguir
  // seria pior do que esperar (e negar já seria um falso 403).
  if (loading) return <CosmicLoader full={false} />;
  if (!can(permission)) return <Navigate to={fallback} replace />;
  return <>{children}</>;
}
